const BIS_TRIGGER_SELECTOR = '#BIS_trigger';
const ADD_TO_CART_SELECTOR = '[data-add-to-cart]';
const ADD_TO_CART_WRAPPER_SELECTORS = [
  '.product-form__item--submit',
  '.sticky-atc-bar__button',
];

function triggerBackInStock() {
  const bisTrigger = document.querySelector(BIS_TRIGGER_SELECTOR);

  if (!bisTrigger) {
    return;
  }

  bisTrigger.click();
}

function isDisabledAddToCart(button) {
  if (!button || !button.matches(ADD_TO_CART_SELECTOR)) {
    return false;
  }

  return button.disabled || button.getAttribute('aria-disabled') === 'true';
}

function getEventPath(event) {
  if (typeof event.composedPath === 'function') {
    return event.composedPath();
  }

  return [event.target];
}

function getButtonFromContainer(container) {
  if (!(container instanceof Element)) {
    return null;
  }

  if (container.matches(ADD_TO_CART_SELECTOR)) {
    return container;
  }

  return container.querySelector(ADD_TO_CART_SELECTOR);
}

function getAddToCartFromEvent(event) {
  const eventPath = getEventPath(event);

  for (const item of eventPath) {
    if (!(item instanceof Element)) {
      continue;
    }

    const directButton = item.closest(ADD_TO_CART_SELECTOR);

    if (directButton) {
      return directButton;
    }

    for (const selector of ADD_TO_CART_WRAPPER_SELECTORS) {
      const wrapper = item.closest(selector);

      if (!wrapper) {
        continue;
      }

      return getButtonFromContainer(wrapper);
    }
  }

  return null;
}

document.addEventListener(
  'pointerdown',
  (event) => {
    const button = getAddToCartFromEvent(event);

    if (!button || !isDisabledAddToCart(button)) {
      return;
    }

    event.preventDefault();

    window.requestAnimationFrame(() => {
      if (!isDisabledAddToCart(button)) {
        return;
      }

      triggerBackInStock();
    });
  },
  true
);

const PRODUCT_MEDIA_VIDEO_SELECTOR = '.product__media [data-media-type="video"] video';
const PRODUCT_SECTION_SELECTOR = '[data-section-type="product"], [data-section-type="featured-product"]';
const PRODUCT_MEDIA_WRAPPER_SELECTOR = '[data-product-media-wrapper]';
const PRODUCT_THUMBNAIL_SELECTOR = '[data-product-thumbnail]';
const PRODUCT_MEDIA_CONTAINER_SELECTOR = '.product__media-container';
const PRODUCT_CAROUSEL_SELECTOR = '.product__media-container.below-mobile.carousel';
const PRODUCT_ACTIVE_SLIDE_SELECTOR = '.swiper-slide-active [data-media-type="video"] video';

function forceProductMediaVideoAutoplay(video) {
  if (!(video instanceof HTMLVideoElement)) {
    return;
  }

  if (!video.closest(PRODUCT_SECTION_SELECTOR)) {
    return;
  }

  video.muted = true;
  video.defaultMuted = true;
  video.autoplay = true;
  video.playsInline = true;

  video.setAttribute('muted', '');
  video.setAttribute('autoplay', '');
  video.setAttribute('playsinline', '');

  if (isProductMediaVideoHidden(video)) {
    return;
  }

  const playPromise = video.play();

  if (playPromise && typeof playPromise.catch === 'function') {
    playPromise.catch(() => {});
  }
}

function isProductMediaVideoHidden(video) {
  const mediaWrapper = video.closest(PRODUCT_MEDIA_WRAPPER_SELECTOR);

  return Boolean(
    mediaWrapper &&
      (mediaWrapper.classList.contains('hidden') ||
        mediaWrapper.classList.contains('product__media-item--hide-on-load') ||
        mediaWrapper.offsetParent === null)
  );
}

function forceProductMediaVideosAutoplay(scope = document) {
  if (!(scope instanceof Document) && !(scope instanceof Element)) {
    return;
  }

  scope
    .querySelectorAll(PRODUCT_MEDIA_VIDEO_SELECTOR)
    .forEach(forceProductMediaVideoAutoplay);
}

function observeProductMediaVideos() {
  forceProductMediaVideosAutoplay();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) {
          return;
        }

        if (node.matches(PRODUCT_MEDIA_VIDEO_SELECTOR)) {
          forceProductMediaVideoAutoplay(node);
          return;
        }

        forceProductMediaVideosAutoplay(node);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function replayProductMediaVideo(video) {
  if (!(video instanceof HTMLVideoElement)) {
    return;
  }

  forceProductMediaVideoAutoplay(video);

  window.setTimeout(() => forceProductMediaVideoAutoplay(video), 100);
  window.setTimeout(() => forceProductMediaVideoAutoplay(video), 300);
}

function replaySelectedProductMediaVideo(mediaContainer, mediaId) {
  if (!mediaContainer || !mediaId) {
    return;
  }

  const targetMedia = mediaContainer.querySelector(
    `${PRODUCT_MEDIA_WRAPPER_SELECTOR}[data-media-item-id="${mediaId}"]`
  );
  const video = targetMedia && targetMedia.querySelector('video');

  replayProductMediaVideo(video);
}

function replayActiveCarouselVideo(carousel) {
  if (!(carousel instanceof Element)) {
    return;
  }

  replayProductMediaVideo(carousel.querySelector(PRODUCT_ACTIVE_SLIDE_SELECTOR));
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) {
    return;
  }

  const thumbnail = event.target.closest(PRODUCT_THUMBNAIL_SELECTOR);

  if (!thumbnail) {
    return;
  }

  const mediaContainer = thumbnail.closest(PRODUCT_MEDIA_CONTAINER_SELECTOR);
  const mediaId = thumbnail.dataset.thumbnailId;

  window.requestAnimationFrame(() => {
    replaySelectedProductMediaVideo(mediaContainer, mediaId);
  });
});

document.addEventListener(
  'transitionend',
  (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const carousel = event.target.closest(PRODUCT_CAROUSEL_SELECTOR);

    if (!carousel) {
      return;
    }

    replayActiveCarouselVideo(carousel);
  },
  true
);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeProductMediaVideos, { once: true });
} else {
  observeProductMediaVideos();
}

function initializeDesktopCompactHeader() {
  const desktopMedia = window.matchMedia('(min-width: 960px)');
  const header = document.querySelector('header[data-enable-sticky-header="true"]');

  if (!header) {
    return;
  }

  const compactAt = 64;
  const expandAt = 16;
  let frameRequested = false;

  function updateCompactState() {
    frameRequested = false;

    if (!desktopMedia.matches) {
      header.classList.remove('is-scroll-compact');
      return;
    }

    if (window.scrollY >= compactAt) {
      header.classList.add('is-scroll-compact');
      return;
    }

    if (window.scrollY <= expandAt) {
      header.classList.remove('is-scroll-compact');
    }
  }

  function requestCompactStateUpdate() {
    if (frameRequested) {
      return;
    }

    frameRequested = true;
    window.requestAnimationFrame(updateCompactState);
  }

  updateCompactState();

  window.addEventListener('scroll', requestCompactStateUpdate, { passive: true });
  desktopMedia.addEventListener('change', updateCompactState);
  document.addEventListener('shopify:section:load', updateCompactState);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeDesktopCompactHeader, { once: true });
} else {
  initializeDesktopCompactHeader();
}
